var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSwapLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10.992 23.951999999999998",
    style: {
      maxHeight: 500
    },
    width: 10.992,
    height: 23.951999999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#333B44",
    d: "M9.01 20.7502C8.94545 20.7502 8.88484 20.7279 8.83356 20.6766L3.82356 15.6666C3.72882 15.5719 3.72882 15.4085 3.82356 15.3137C3.91829 15.219 4.08171 15.219 4.17645 15.3137L9.18645 20.3237C9.27932 20.4166 9.28115 20.5755 9.19195 20.6709C9.12626 20.7294 9.05816 20.7502 9.01 20.7502Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#333B44",
    d: "M9.01001 20.75C8.87615 20.75 8.76001 20.6339 8.76001 20.5V3.5C8.76001 3.36614 8.87615 3.25 9.01001 3.25C9.14387 3.25 9.26001 3.36614 9.26001 3.5V20.5C9.26001 20.6339 9.14387 20.75 9.01001 20.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#333B44",
    d: "M20.01 8.75994C19.9455 8.75994 19.8848 8.73768 19.8336 8.68639L14.8236 3.67639C14.7288 3.58165 14.7288 3.41823 14.8236 3.32349C14.9183 3.22876 15.0817 3.22876 15.1764 3.32349L20.1865 8.33349C20.2812 8.42823 20.2812 8.59165 20.1865 8.68639C20.1352 8.73768 20.0745 8.75994 20.01 8.75994Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#333B44",
    d: "M14.99 21.25C14.58 21.25 14.24 20.91 14.24 20.5V3.5C14.24 3.09 14.58 2.75 14.99 2.75C15.4 2.75 15.74 3.09 15.74 3.5V20.5C15.74 20.91 15.41 21.25 14.99 21.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSwapLeft);
export default __webpack_public_path__ + "static/media/arrow-swap-left.f4badbecf4f143b2a1043aba5c4c909a.svg";
export { ForwardRef as ReactComponent };